

const storePresentationConfig = (state = [], action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default storePresentationConfig;
